<template>
	<div id="body1">
		<nav id="navbar" class="navbar navbar-expand-lg navbar-dark px-4 w-100">
			<router-link class="navbar-brand" :to="{name: 'home'}">
				<img class="navbar-img" src="/images/logo.png" />
			</router-link>
			<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>
			<div class="collapse navbar-collapse" id="navbarNav" style="width: 100%;">
				<div class="d-flex w-100 justify-content-between">
					<ul class="navbar-nav">
						<li class="nav-item active" >
							<router-link :to="{ name: 'home' }" class="nav-link fs-5 px-2">
								<p class="d-block d-lg-none m-0" data-bs-toggle="collapse" data-bs-target="#navbarNav">{{ $t('home') }}  </p>
								<p class="d-none d-lg-block m-0" >{{ $t('home') }}  </p>
							</router-link>
						</li>
						<li class="nav-item">
							<router-link :to="{ name: 'categories' }" class="nav-link fs-5 px-2">
								<p class="d-block d-lg-none m-0" data-bs-toggle="collapse" data-bs-target="#navbarNav">{{ $t('categories') }}  </p>
								<p class="d-none d-lg-block m-0" >{{ $t('categories') }}  </p>
							</router-link>
						</li>
						<li class="nav-item">
							<router-link :to="{ name: 'news' }" class="nav-link fs-5 px-2">
								<p class="d-block d-lg-none m-0" data-bs-toggle="collapse" data-bs-target="#navbarNav">{{ $t('news') }}  </p>
								<p class="d-none d-lg-block m-0" >{{ $t('news') }}  </p>
							</router-link>
						</li>
						<li class="nav-item">
							<router-link :to="{ name: 'albums' }" class="nav-link fs-5 px-2" href="">
								<p class="d-block d-lg-none m-0" data-bs-toggle="collapse" data-bs-target="#navbarNav">{{ $t('albums') }}  </p>
								<p class="d-none d-lg-block m-0" >{{ $t('albums') }}  </p>
							</router-link>
						</li>
						<li class="nav-item">
							<router-link :to="{ name: 'contact' }" class="nav-link fs-5 px-2">
								<p class="d-block d-lg-none m-0" data-bs-toggle="collapse" data-bs-target="#navbarNav">{{ $t('contact') }}  </p>
								<p class="d-none d-lg-block m-0" >{{ $t('contact') }}  </p>
							</router-link>
						</li>
						<li class="nav-item">
							<router-link :to="{ name: 'about' }" class="nav-link fs-5 px-2">
								<p class="d-block d-lg-none m-0" data-bs-toggle="collapse" data-bs-target="#navbarNav">{{ $t('about') }}  </p>
								<p class="d-none d-lg-block m-0" >{{ $t('about') }}  </p>
							</router-link>
						</li>
						<li class="nav-item px-md-2">
							<a class="nav-link fs-5 px-2" @click="toggleLanguage()">{{ $t('HomePage.lang') }}</a>
							<!-- <a class="nav-link" href="">ع</a> -->
						</li>
					</ul>
					<ul class="d-none d-lg-block navbar-nav mlr-auto">
						<li class="social-media-navBar">
							<a target="_blank" href="https://www.facebook.com/ArabicaChips"><span><i
										class="fab fa-facebook-square mr-2"></i></span></a>
							<a target="_blank" href="https://instagram.com/arabicachips"><span><i
										class="fab fa-instagram mr-2"></i></span></a>
							<a target="_blank" href="https://t.me/Arabica_chips"><span><i
										class="fab fa-telegram mr-2"></i></span></a>
						</li>
					</ul>
				</div>
			</div>
		</nav>
	</div>
</template>
<script>
import axios from '../axios'
import { mapActions } from 'vuex';
import gsap from 'gsap'
export default {
	mounted() {
		gsap.to('#body1', {
			y: -200,
			opacity: 0,
			scrollTrigger: {
				trigger: '#body1',
				start: '0%',
				end: '+=300',
				scrub: 1
			}
		})
		// if (this.$route.path === '/') {
		// 	gsap.to('#body1', {
		// 		y: -100,
		// 		opacity: 0,
		// 		scrollTrigger: {
		// 			trigger: '#body1',
		// 			start: '2000',
		// 			end: '+=200',
		// 			scrub: 1
		// 		}
		// 	})
		// } else {
	
		// }
	},
	computed: {
		lang() {
			return this.$i18n.locale === 'en';
		},
	},
	methods: {
		...mapActions({
			news: 'news/fetchNews',
			categories: 'categories/fetchCategories',
			albums: 'albums/fetchAlbums'
		}),
		resetApi() {
			this.$router.go(0);
		},
		toggleLanguage() {
			this.resetApi();
			const newLang = localStorage.getItem('lang') === 'en' ? 'ar' : 'en';
			axios.defaults.headers.common['Accept-Language'] = newLang;
			localStorage.setItem('lang', newLang);
		}

	}
}
</script>
<style lang="scss"></style>
